import "./Home.scss";
import HomeHero from "../../components/home/HomeHero/HomeHero";
import HomeAbout from "../../components/home/HomeAbout/HomeAbout";
import HomeCareersSection from "../../components/home/HomeCareersSection/HomeCareersSection";
import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useRef } from "react";
import { useTheme } from "../../context/ThemeContext";

function Home({ CLOUDFRONT_URL }) {
  const { setThemeByName } = useTheme();

  useEffect(() => {
    setThemeByName("default");

    return () => {
      setThemeByName("default");
    };
  }, [setThemeByName]);
  // Create refs for each section that will have parallax
  const containerRef = useRef(null);
  const careersRef = useRef(null);

  const { scrollYProgress: careersProgress } = useScroll({
    target: careersRef,
    offset: ["start end", "end start"],
  });

  const careersY = useTransform(careersProgress, [0, 1], ["0%", "-20%"]);

  return (
    <div className="home">
      <HomeHero CLOUDFRONT_URL={CLOUDFRONT_URL} />
      <HomeAbout CLOUDFRONT_URL={CLOUDFRONT_URL} />
      <div className="home__sections" ref={containerRef}>
        <motion.div
          ref={careersRef}
          className="parallax-section"
          style={{ y: careersY }}
        >
          <div className="home__section">
            <HomeCareersSection CLOUDFRONT_URL={CLOUDFRONT_URL} />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Home;
